import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { DialogService, TreeNode, MenuItem, MessageService } from 'primeng/api';
import { Subject } from 'rxjs/Subject';
// import { CookieService } from 'ngx-cookie-service';

import { IPaginatedTable } from 'src/app/Interfaces/IPaginatedTable'
import { PaginatedTable } from 'src/app/Components/PaginatedTable/PaginatedTable'

import 'rxjs/add/operator/debounceTime';

import { environment } from 'src/environments/environment';
import { state, trigger, style, transition, animate } from '@angular/animations';

import { BaseHandbook } from 'src/app/Models/Handbooks/Base/BaseHandbook';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { HandbookDescriptor } from 'src/app/Models/Handbooks/Base/HandbookDescriptor';
import { Activity } from 'src/app/Models/Handbooks/Activity';
import { Industry } from 'src/app/Models/Industry';
import { ReformatIndustry } from '../../Indicators/List/Helpers';
import { CreateSphereComponent } from './CreateSphere';
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';

@Component({
    // host: {
    //     '[@routeAnimation]': 'true'
    // },
    selector: 'app-industries-handboook-editor',
    templateUrl: './Industries.html',
    styleUrls: [],
    providers: [DialogService, MessageService, TranslatePipe, CurrentLangPipe],
    animations: []
})
export class IndustriesHandbookComponent implements OnInit {
    
    treeLoading: boolean = false;
    getIndustries() {
        this.treeLoading = true;
        return this.http.get(`${environment.apiUrl}/api/Industries/Tree`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    getIndustry(id: number) {
        this.industryLoading = true;
        return this.http.get(`${environment.apiUrl}/api/Industries/Get/${id}`, {
            headers: { "Content-Type": "application/json" }
        });
    }
    Industries: Array<Industry> = [];
    IndustriesTree: TreeNode[] = [];
    IndustriesSelectedNodes: TreeNode[] = [];
    SelectedIndustryNode: TreeNode = {};
    
    UpdatingBool: boolean = false;
    industryLoading: boolean = false;
    Current: Industry = null;

    getActivities() {
        return this.http.get(`${environment.apiUrl}/api/Activities/List`, {
            headers: {
                "Content-Type": "application/json"
            }
        });
    }
    Activities: Activity[] = [];
    get ActivitiesOptions(): Array<any> {
        return this.Activities.map((x) => ({ label: x.NameRu, value: x.Id }))
    }
    
    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private router: Router,
        public dialogService: DialogService,
        private messageService: MessageService,
        private translatePipe: TranslatePipe,
        private currentLangPipe: CurrentLangPipe,
        // private cookieService: CookieService
    ) {

    }

    ngOnInit(): void {
        this.getActivities().subscribe((data: Array<Activity>) => {
            this.Activities = data
        })
        this.getIndustries().subscribe((data: Array<Industry>) => {
            this.treeLoading = false;
            this.Industries = data;
            this.IndustriesTree = this.Industries.map(x => ReformatIndustry(x, this.currentLangPipe.get()))
        })
    }

    nodeSelect(event) {
        this.Current = null
        this.SelectedIndustryNode = event.node
        this.getIndustry(this.SelectedIndustryNode.data).subscribe((data: Industry) => {
            this.industryLoading = false;
            this.Current = data;
        })
    }

    SaveChanges() {
        this.UpdatingBool = true;
        this.http.put(`${environment.apiUrl}/api/Industries/Update`, JSON.stringify({
            Id: this.Current.Id,
            Name: this.Current.Name,
            NameEn: this.Current.NameEn,
            NameKz: this.Current.NameKz
        }), {
            headers: {
                "Content-Type": "application/json",
                // "Authorization": `bearer ${this.cookieService.get('token')}`
            }
        }).subscribe(
            (data: Industry) => {
                var lang = this.currentLangPipe.get()
                this.messageService.add({
                    severity: 'success',
                    summary: this.translatePipe.transform('warnings.saved'),
                    detail: this.translatePipe.transform('warnings.industryElementHasBeenSaved')
                });

                this.SelectedIndustryNode.label = (lang == 'ru')
                    ? data.Name
                    : (lang == 'kk')
                        ? data.NameKz
                        : data.NameEn,

                this.UpdatingBool = false;
            },
            err => {
                this.UpdatingBool = false;
            },
            () => {
                this.UpdatingBool = false;
            }
        )
    }

    showSphereCreationDialogue(isSphere: boolean = false) {
        const ref = this.dialogService.open(CreateSphereComponent, {
            header: isSphere
                ? this.translatePipe.transform('warnings.youReCreatingIndustrySphere')
                : this.translatePipe.transform('warnings.youReCreatingIndustryBranch'),
            data: {
                isSphere,
                parent: isSphere ? null : this.Current
            },
            width: '30%',
            contentStyle: {
                'padding': '0px'
            }
        });
        ref.onClose.subscribe((isCreated: boolean) => {
            if (isCreated) {
                this.Current = null;
                this.getIndustries().subscribe((data: Array<Industry>) => {
                    this.treeLoading = false;
                    this.Industries = data;
                    this.IndustriesTree = this.Industries.map(x => ReformatIndustry(x, this.currentLangPipe.get()))
                })
            }
        });
    }

}